import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="Settings">
      <h1>Settings</h1>
    </div>
  );
};

export default Settings;
